let sessionVersion = 0
export const getSessionVersion = () => sessionVersion
export const invalidateSession = () => { sessionVersion += 1 }
export const TOKEN_KEY = 'token'
export const REFRESH_TOKEN_KEY = 'refreshToken'

export const getAccessToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY)
  } catch (_) {
    return null
  }
}

export const getRefreshToken = () => {
  try {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY)
  } catch (_) {
    return null
  }
}

export const isSessionStoragePreferred = () => {
  try {
    return !!sessionStorage.getItem(REFRESH_TOKEN_KEY) || !!sessionStorage.getItem(TOKEN_KEY)
  } catch (_) {
    return false
  }
}

export const setTokens = ({ access, refresh, remember }) => {
  sessionVersion += 1
  const useLocal = remember === true
  try {
    if (useLocal) {
      if (access) localStorage.setItem(TOKEN_KEY, access)
      if (refresh) localStorage.setItem(REFRESH_TOKEN_KEY, refresh)
      sessionStorage.removeItem(TOKEN_KEY)
      sessionStorage.removeItem(REFRESH_TOKEN_KEY)
    } else {
      if (access) sessionStorage.setItem(TOKEN_KEY, access)
      if (refresh) sessionStorage.setItem(REFRESH_TOKEN_KEY, refresh)
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
    }
  } catch (_) {}
}

export const setAccessToken = (access) => {
  if (!access) return
  try {
    if (isSessionStoragePreferred()) sessionStorage.setItem(TOKEN_KEY, access)
    else localStorage.setItem(TOKEN_KEY, access)
  } catch (_) {}
}

export const clearTokens = () => {
  sessionVersion += 1
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem('auth')
    localStorage.removeItem('enrollments')
  } catch (_) {}
  try {
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  } catch (_) {}
}
